/**
 * Strip HTML tags from a string for plain text display (e.g. document.title).
 * Handles RichTextField values that may contain HTML.
 */
export const stripHtml = (html) => {
  if (!html || typeof html !== 'string') return html || '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

/** True when an HTML string has no visible content (e.g. "<p></p>", "<p>&nbsp;</p>"). */
export const isEmptyHtml = (html) => {
  if (!html) return true;
  return String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;|\u00a0/g, ' ').trim() === '';
};
